export interface Factory {
  slug: string
  i18nKey: string // e.g., 'factories.cmc_factory'
  image: string
  stats?: {
    employees: string
    productsKey?: string // i18n key for products capacity text
  }
  link?: string
  gallery?: string[]
}

export interface SupplierSectionRef {
  key: string // e.g., 'sections.fabric_materials'
  imageSrc: string
  imagePosition: 'left' | 'right'
}

export const supplierSections: SupplierSectionRef[] = [
  {
    key: 'sections.fabric_materials',
    imageSrc: '/image/June2025/mceclip41_26.png',
    imagePosition: 'right',
  },
  {
    key: 'sections.skilled_producers',
    imageSrc: '/image/June2025/mceclip42_65.png',
    imagePosition: 'left',
  },
]

export const factories: Factory[] = [
  {
    slug: 'ykk-factory',
    i18nKey: 'factories_detail.ykk_factory',
    image: '/image/August2025/mceclip9_73.jpg',
    stats: {
      employees: '1.400+ lao động',
      productsKey: 'factories_detail.ykk_factory.products',
    },
    link: '/page/ykk-viet-nam',
  },
  {
    slug: 'avery-dennision',
    i18nKey: 'factories_detail.avery_dennision',
    image: '/image/August2025/mceclip18_35.jpg',
    stats: {
      employees: '3.000+ lao động',
      productsKey: 'factories_detail.avery_dennision.products',
    },
    link: '/page/avery-dennision-viet-nam',
  },
  {
    slug: 'cmc-factory',
    i18nKey: 'factories_detail.cmc_factory',
    image: '/image/June2025/mceclip0_62.png',
    stats: {
      employees: '700+ lao động',
      productsKey: 'factories_detail.cmc_factory.products',
    },
    gallery: [
      '/image/June2025/mceclip0_62.png',
      '/image/June2025/mceclip1_7.jpg',
      '/image/June2025/mceclip2_37.png',
    ],
  },
  {
    slug: 'cheau-liang-factory',
    i18nKey: 'factories_detail.cheau_liang_factory',
    image: '/image/June2025/mceclip3_63.jpg',
    stats: {
      employees: '~700 lao động',
      productsKey: 'factories_detail.cheau_liang_factory.products',
    },
    gallery: [
      '/image/June2025/mceclip3_63.jpg',
      '/image/June2025/mceclip5_38.jpg',
      '/image/June2025/mceclip4_64.jpg',
    ],
  },
  {
    slug: 'viet-nga',
    i18nKey: 'factories_detail.viet_nga',
    image: '/image/June2025/mceclip10_40.jpg',
    stats: {
      employees: '200+ lao động',
      productsKey: 'factories_detail.viet_nga.products',
    },
    gallery: [
      '/image/June2025/mceclip10_40.jpg',
      '/image/June2025/mceclip6_61.jpg',
      '/image/June2025/mceclip8_18.jpg',
      '/image/June2025/mceclip7_15.jpg',
    ],
  },
  {
    slug: 'tng',
    i18nKey: 'factories_detail.tng',
    image: '/image/June2025/mceclip16_3.jpg',
    stats: {
      employees: '~1.250 lao động',
      productsKey: 'factories_detail.tng.products',
    },
    gallery: [
      '/image/June2025/mceclip16_3.jpg',
      '/image/June2025/mceclip15_57.jpg',
      '/image/June2025/mceclip13_36.jpg',
      '/image/June2025/mceclip14_31.jpg',
    ],
  },
  {
    slug: 'tdt',
    i18nKey: 'factories_detail.tdt',
    image: '/image/June2025/mceclip2_6.jpg',
    stats: {
      employees: '~723 lao động',
      productsKey: 'factories_detail.tdt.products',
    },
    gallery: [
      '/image/June2025/mceclip2_6.jpg',
      '/image/June2025/mceclip18_23.jpg',
      '/image/June2025/mceclip19_12.jpg',
      '/image/June2025/mceclip17_22.jpg',
    ],
  },
  {
    slug: 'nguon-luc',
    i18nKey: 'factories_detail.nguon_luc',
    image: '/image/June2025/mceclip20_28.jpg',
    stats: {
      employees: '~580 lao động',
      productsKey: 'factories_detail.nguon_luc.products',
    },
    gallery: [
      '/image/June2025/mceclip20_28.jpg',
      '/image/June2025/mceclip26_64.jpg',
      '/image/June2025/mceclip22_82.jpg',
      '/image/June2025/mceclip21_38.jpg',
    ],
  },
  {
    slug: 'grace',
    i18nKey: 'factories_detail.grace',
    image: '/image/June2025/mceclip32.jpg',
    stats: {
      employees: '~500 lao động',
      productsKey: undefined,
    },
    gallery: [
      '/image/June2025/mceclip32.jpg',
      '/image/June2025/mceclip29.jpg',
      '/image/June2025/mceclip27.jpg',
      '/image/June2025/mceclip28.jpg',
    ],
  },
  {
    slug: 'tessellation',
    i18nKey: 'factories_detail.tessellation',
    image: '/image/June2025/mceclip36.jpg',
    stats: {
      employees: '3.200+ lao động',
      productsKey: 'factories_detail.tessellation.products',
    },
    link: '/page/nha-may-tessellation-tgv',
  },
  {
    slug: 'scavi',
    i18nKey: 'factories_detail.scavi',
    image: '/image/June2025/mceclip38_51.jpg',
    stats: {
      employees: '10.000+ lao động',
      productsKey: undefined,
    },
    link: '/page/nha-may-scavi',
  },
  {
    slug: 'son-ha',
    i18nKey: 'factories_detail.son_ha',
    image: '/image/July2022/photo_2022-06-22_13.43.511.jpeg',
    stats: {
      employees: '600+ lao động',
      productsKey: 'factories_detail.son_ha.products',
    },
    link: '/page/nha-may-son-ha',
  },
  {
    slug: 'vitajeans',
    i18nKey: 'factories_detail.vitajiens',
    image: '/image/June2025/mceclip37.jpg',
    stats: {
      employees: '1.000+',
      productsKey: undefined,
    },
    link: '/page/nha-may-vitajeans',
  },
  {
    slug: 'vietstar-factory',
    i18nKey: 'factories_detail.vietstar_factory',
    image: '/image/August2025/mceclip.jpg',
    gallery: [
      '/image/August2025/mceclip.jpg',
      '/image/August2025/mceclip2_14.jpg',
      '/image/August2025/mceclip3_42.jpg',
      '/image/August2025/mceclip4_82.jpg',
      '/image/August2025/mceclip5_22.jpg',
      '/image/August2025/mceclip67_(1).jpg',
    ],
    //  Đang tạm fix cứng thế này sau có ảnh bỏ đi slug === 'vietstar-factory' && 'object-none'
  },
]
